import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NetworkView from "@/pages/NetworkView";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NetworkView />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
